import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link
                to="/"
                className="flex items-center gap-2 text-foreground-950 mb-4"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-read-line text-2xl text-primary-500"></i>
                </div>
                <span className="font-heading text-xl font-bold whitespace-nowrap">
                  韩漫漫画网
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                韩漫漫画网汇聚免费韩漫、海量漫画大全、优质在线漫画及精选韩国漫画，致力于提供专业的阅读服务。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">
                快速导航
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/romance"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    漫画分类
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">
                热门分类
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/category/romance"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    恋爱言情
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/fantasy"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    奇幻冒险
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/action"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    热血动作
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/thriller"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    悬疑惊悚
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">
                联系方式
              </h4>
              <ul className="flex flex-col gap-2.5 text-sm text-foreground-600">
                <li className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <span>contact@manhuacomic.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-primary-500"></i>
                  </div>
                  <span>在线客服：工作日 9:00-18:00</span>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-1 text-primary-500 hover:text-primary-600 transition-colors text-sm font-medium"
                  >
                    了解更多
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 韩漫漫画网. 本站所有漫画内容均来源于网络，仅供学习交流使用。
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="#"
                  className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors"
                  rel="nofollow"
                >
                  隐私政策
                </a>
                <a
                  href="#"
                  className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors"
                  rel="nofollow"
                >
                  服务条款
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}